export class Chongzhi {
    recharge;
    gift;
}

export class Xini {
    gift = "";
    giftType;
    goodsName;
    giftId;
    message;
    type;
}

export class Choujiang {
    goodsName;
    type;
    activityId;
}